<div class="inbuilt-visual">
    <div class="inbuilt-visual__header">
        <span class="inbuilt-visual__icon">
            <mat-icon aria-hidden="true">bar_chart</mat-icon>
        </span>
        <h2 class="inbuilt-visual__title">Add visual</h2>
    </div>
    <p class="inbuilt-visual__description">
        Choose a chart, table, or metric to turn the filtered data into a report component.
    </p>
    <button type="button" class="inbuilt-visual__button"  (click)="addVisual.emit()">
        <mat-icon aria-hidden="true">add</mat-icon>
        <span>Add visual</span>
    </button>
</div>
